import { render, staticRenderFns } from "./CToggle.vue?vue&type=template&id=be968162&"
import script from "./CToggle.vue?vue&type=script&lang=js&"
export * from "./CToggle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports